import isbot from 'isbot';

// Same detection as sourcepoint-lib, which also skips bots for consent metrics.
isbot.extend(['Google-Read-Aloud']);

const isBot = (userAgent: string = window.navigator.userAgent): boolean => {
  try {
    return userAgent ? isbot(userAgent) : false;
  } catch {
    return true;
  }
};

export default isBot;
